export enum SUIT {
    NONE = 0,
    CLUBS = 1,
    DIAMONDS = 2,
    HEARTS = 3,
    SPADES = 4,
    NOTRUMP = 5,
    CLUBS_GREEN = 6,
    DIAMONDS_BLUE = 7,
}

const CARD_BASE_CODE = 'A'.charCodeAt(0);

export default class Card {
    height = 0; // 1 = ace, 2 = king, 3 = queen, 4 = jack, 5 = ten, etc
    suit = 0;
    played = false;
    face = true;

    static fromChar(c: string) {
        const card = new Card();

        if (c.length === 1) {
            // server provided char
            card.setInt(c.charCodeAt(0) - CARD_BASE_CODE);
        } else {
            console.error('Card char is invalid', c);
        }
        return card;
    }

    static fromInt(c: number) {
        return new Card().setInt(c);
    }

    static fromObject(o: any | Card) {
        const c = new Card();
        c.height = o.height ?? 0;
        c.suit = o.suit ?? 0
        c.played = o.played ?? false;
        c.face = o.face ?? true;
        return c;
    }

    static fromAny(cc: string | number | Card) {
        if (typeof cc === 'string') {
            return Card.fromChar(cc);
        } else if (typeof cc === 'number') {
            return Card.fromInt(cc);
        } else if (typeof cc === 'object') {
            return Card.fromObject(cc);
        }
        console.error('Unknown typed card.');
        return new Card();
    }

    clone() {
        return Card.fromObject(this);
    }

    lessThen(b: Card) { return this.getInt() < b.getInt() };
    greaterThen(b: Card) { return this.getInt() > b.getInt() };
    equals(that: Card) {
        return that && this.getInt() === that.getInt()
    }

    isValid() {
        return this.getInt() > 0;
    }

    getInt(): number {
        let c = 0;

        switch (this.suit) {
            case SUIT.SPADES:
                c = 0;
                break;
            case SUIT.HEARTS:
                c = 13;
                break;
            case SUIT.DIAMONDS:
                c = 26;
                break;
            case SUIT.CLUBS:
                c = 39;
                break;
            default:
                return 0;
        }

        if (this.height > 13 || this.height < 1) {
            return 0;
        }

        return c + this.height;
    }

    setInt(i: number) {
        if (i == 0) {
            this.suit = SUIT.NONE;
        } else if (i < 14)
            this.suit = SUIT.SPADES;
        else if (i < 27)
            this.suit = SUIT.HEARTS;
        else if (i < 40)
            this.suit = SUIT.DIAMONDS;
        else
            this.suit = SUIT.CLUBS;

        this.height = 1 + ((i - 1) % 13);
        return this;
    }

    higherThan(card: Card): boolean {
        // the lower the card the higher
        if (card.suit == this.suit) {
            return this.height < card.height;
        }
        return false;
    }

    /**
     * represents card value in server format
     */
    toChar() {
        return this.isValid() ? String.fromCharCode(CARD_BASE_CODE + this.getInt()) : '';

    }

    toString() {
        let h = "-AKQJT98765432";
        let s = "-CDHS";

        let si = this.suit;
        let hi = this.height;

        return s.substring(si, si + 1) + h.substring(hi, hi + 1);
    }

    toStringReverse() {
        let h = "-AKQJT98765432";
        let s = "-CDHS";

        let si = this.suit;
        let hi = this.height;

        return h.substring(hi, hi + 1) + s.substring(si, si + 1);
    }

    fromString(s: string) {
        this.height = "-AKQJT98765432".indexOf(s[1]) ?? 0
        this.suit = "-CDHS".indexOf(s[0]) ?? 0
        return this;
    }
}